import { render, staticRenderFns } from "./selectExam.vue?vue&type=template&id=5d40587a&"
import script from "./selectExam.vue?vue&type=script&lang=js&"
export * from "./selectExam.vue?vue&type=script&lang=js&"
import style0 from "./selectExam.vue?vue&type=style&index=0&id=5d40587a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports